import { SidebarProvider } from "@ui/components/ui/sidebar";
import { type PropsWithChildren } from "react";

import { BreadcrumbsProvider } from "src/contexts/BreadcrumbsContext";

import { AuthenticatedNavigation } from "./AuthenticatedNavigation";
import { AuthenticatedNavigationContextProvider } from "./AuthenticatedNavigationContext";
import { Sidebar } from "./Sidebar";

type Props = PropsWithChildren;

export function AuthLayout(props: Props) {
  return (
    <SidebarProvider>
      <BreadcrumbsProvider>
        <Sidebar />
        <AuthenticatedNavigationContextProvider>
          <main className="w-full h-full">
            <AuthenticatedNavigation sidebarShown />
            {props.children}
          </main>
        </AuthenticatedNavigationContextProvider>
      </BreadcrumbsProvider>
    </SidebarProvider>
  );
}
